import * as React from "react";
import { WithStyles, withStyles, createStyles } from './styles';

const styles = () => createStyles({

    root: {
        padding: 16,
        position: 'relative',
        width: '100%',
        backgroundColor: 'red',
    },

    message: {
        textAlign: 'center',
        color: 'yellow',
    },
});

const View = withStyles(styles)((props: WithStyles<typeof styles>) => {

    const { classes } = props;

    return <div className={classes.root}>
        <div className={classes.message}>{"Při načítání stránky došlo k chybě."}</div>
    </div>;
});

export {
    View as LoadingError
}
